import { Box, CircularProgress } from '@mui/material';

import { FProgressBar } from '../../../../../../components/base';
import { FORTA_BLUE } from '../../../../../../utils/colors';
import { QuestionnaireSectionLabel } from '../../../../common';
import {
  InsuranceCardFieldsSection,
  InsuranceInformationFields,
  PolicyholderInformationFields,
} from './components';
import { useInsuranceFormState } from './hooks';
import { LOADING_OVERLAY_SX } from './styles';

import type { InsuranceFormProps } from './types';

export default function InsuranceForm({ insuranceType, showTitle = true }: InsuranceFormProps) {
  const {
    title,
    formik,
    isLoading,
    isUpdating,
    isDocumentActionLoading,
    cardFields,
    informationFields,
    policyholderFields,
  } = useInsuranceFormState(insuranceType);

  return (
    <>
      {showTitle ? (
        <QuestionnaireSectionLabel variant="h5" sx={{ mb: 1.5, color: FORTA_BLUE.primary }}>
          {title}
        </QuestionnaireSectionLabel>
      ) : null}
      <Box
        component="form"
        noValidate
        onSubmit={formik.handleSubmit}
        sx={{ display: 'flex', flexDirection: 'column', gap: 3, position: 'relative' }}
      >
        {isUpdating || isDocumentActionLoading ? <FProgressBar /> : null}
        {isLoading ? (
          <Box sx={LOADING_OVERLAY_SX}>
            <CircularProgress size={32} />
          </Box>
        ) : null}
        <InsuranceCardFieldsSection {...cardFields} />
        <InsuranceInformationFields {...informationFields} />
        <PolicyholderInformationFields {...policyholderFields} />
      </Box>
    </>
  );
}
